import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ApplyPage } from '@/features/apply';

/** Public brand application. No session guard: a signed-in staff member may apply for a new brand. */
export const Route = createFileRoute('/(public)/apply/')({
  validateSearch: z.object({ source: z.string().max(120).optional().catch(undefined) }),
  component: ApplyRoute,
});

function ApplyRoute() {
  const { source } = Route.useSearch();
  return <ApplyPage source={source} />;
}
